"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

require("./ListDropDown.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListDropDown = function ListDropDown(_ref) {
  var target = _ref.target,
      isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
    target: target,
    isOpen: isOpen,
    toggle: toggle,
    placement: "bottom-start",
    hideArrow: true,
    trigger: "legacy",
    popperClassName: "gcl-list-dropdown"
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, {
    className: "gcl-ldd-menu-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ldd-menu-wrap"
  }, children)));
};

var ListItem = function ListItem(_ref2) {
  var onClick = _ref2.onClick,
      username = _ref2.username,
      extraUserInfo = _ref2.extraUserInfo,
      icon = _ref2.icon,
      focused = _ref2.focused,
      onFocus = _ref2.onFocus;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-ldd-option' + (focused ? ' focused' : ''),
    onClick: onClick,
    onMouseOver: onFocus
  }, icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ldd-icon-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(icon)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ldd-useinfo-wrapper"
  }, username && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ldd-username"
  }, username), extraUserInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ldd-extraUserInfo"
  }, extraUserInfo)));
};

exports.ListItem = ListItem;
ListDropDown.propTypes = {
  target: _propTypes["default"].string.isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  toggle: _propTypes["default"].func.isRequired
};
var _default = ListDropDown;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/ListDropDown/ListDropDown.js
// module id = 698
// module chunks = 0